import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierSC-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import SLPolicyChangesPage from './pages/SLPolicyChanges/SLPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierSLPolicyChangesPage: { component: 'PremierSLPolicyChangesPage' }
    },
    {
        PremierSLPolicyChangesPage: SLPolicyChangesPage
    }
);

export { default as PremierSLPolicyChangeWizard } from './PremierSLPolicyChangeWizard';
